import { GeoIpCoordinatesService } from "../shared/geoLocation/GeoIpCoordinatesService";
import { Coordinates } from "../shared/geoLocation/GeoCoordinatesService";
import { injectable, singleton } from "tsyringe";
import { Logger } from "../utils/Logger";

/**
 * Service to retrieve the user's coordinates from the browser's session storage.
 */
@injectable()
@singleton()
export class ToutvGeoCoordinatesService implements GeoIpCoordinatesService {
  public getCoordinates(): Coordinates | undefined {
    let storageKey: string;
    switch (Environment) {
      case "production":
        storageKey = "toutv_user_geo_production";
        break;
      default:
        storageKey = "toutv_user_geo_development";
        break;
    }
    const storedCoordinates = sessionStorage.getItem(storageKey);
    if (!storedCoordinates) {
      Logger.verbose(`No coordinates found in session storage using key: ${storageKey}.`);
      return undefined;
    }
    const coordinates = JSON.parse(storedCoordinates) as Coordinates;
    if (!coordinates.longitude || !coordinates.latitude) {
      Logger.verbose(`Longitude and/or latitude are missing.`);
      return undefined;
    }
    return coordinates;
  }
}
